"use client";

import React, { useEffect, useState } from "react";
import { useCarouselContext } from "../CarouselProvider";
import classNames from "@/helpers/classNames";
import styles from "./styles.module.scss";

interface CarouselDotsProps {
  theme?: "light" | "dark";
  dotSize?: "xs" | "sm" | "md" | "lg";
  className?: string;
}

const CarouselDots: React.FC<CarouselDotsProps> = (props) => {
  const { className, theme = "light", dotSize = "lg" } = props;
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [scrollSnaps, setScrollSnaps] = useState<number[]>([]);
  const { carousel } = useCarouselContext();

  useEffect(() => {
    if (!carousel) {
      return;
    }

    const onSelect = () => {
      if (!carousel) {
        return;
      }
      setSelectedIndex(carousel.selectedScrollSnap());
    };

    carousel.on("select", onSelect);
    setScrollSnaps(carousel.scrollSnapList());
    onSelect();

    return () => {
      carousel.off("scroll", onSelect);
    };
  }, [carousel]);

  const handleOnClick = (index: number) => {
    if (!carousel) {
      return;
    }
    carousel.scrollTo(index);
  };

  return (
    <div className={classNames(styles.container, className)} data-theme={theme}>
      {scrollSnaps?.map((_, index) => (
        <button
          type="button"
          key={index}
          aria-label={`Go to slide ${index + 1}`}
          className={classNames(styles.dot, styles[`size_${dotSize}`], {
            [styles.selected]: index === selectedIndex,
          })}
          onClick={() => handleOnClick(index)}
        />
      ))}
    </div>
  );
};

export default CarouselDots;
